import { render, staticRenderFns } from "./SettingsBlock.vue?vue&type=template&id=b294250a&scoped=true&"
import script from "./SettingsBlock.vue?vue&type=script&lang=js&"
export * from "./SettingsBlock.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBlock.vue?vue&type=style&index=0&id=b294250a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b294250a",
  null
  
)

export default component.exports